import * as tslib_1 from "tslib";
import strings from 'owa-strings/owa-mail-strings';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getComposeHostItemIndex, isAnyUilessAddinRunning } from 'owa-addins-core';
export function uiLessAddinIsRunning(viewState) {
    return (isMailFeatureEnabled('rp-addins') &&
        isAnyUilessAddinRunning(getComposeHostItemIndex(viewState.composeId)));
}
export default function blockOnNavigation(viewState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!uiLessAddinIsRunning(viewState)) {
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, confirm(strings.blockOnNavigationTitle, strings.blockOnNavigationMessage, 
                        /* resolveImmediately? */ false, {
                            okText: strings.blockOnNavigationContinueLabel,
                            cancelText: strings.blockOnNavigationCancelLabel,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response === DialogResponse.cancel || response === DialogResponse.dismiss];
            }
        });
    });
}
//# sourceMappingURL=blockOnNavigation.js.map